<template>
    <main class="page page-dashboard">
        <div class="container">
            <PageHeader
                :title="$translate.text('clients.add')"
            />

            <p>{{ t('clients.add.explanation') }}

            <form @submit.prevent="submitForm" method="POST">
                <h4>{{ t('general.company_information') }}</h4>

                <TextInput
                    id="company"
                    :value="company"
                    name="company"
                    @change="company = $event"
                    :label="$translate.text('general.company.name')"
                />

                <TextInput
                    id="clientStreet"
                    :value="clientStreet"
                    name="clientStreet"
                    @change="clientStreet = $event"
                    :label="$translate.text('general.address.address')"
                />

                <TextInput
                    id="clientZipcode"
                    :value="clientZipcode"
                    name="clientZipcode"
                    @change="clientZipcode = $event"
                    :label="$translate.text('general.address.zipcode')"
                />

                <TextInput
                    id="clientCity"
                    :value="clientCity"
                    name="clientCity"
                    @change="clientCity = $event"
                    :label="$translate.text('general.address.city')"
                />

                <TextInput
                    id="clientPhone"
                    :value="clientPhone"
                    name="clientPhone"
                    @change="clientPhone = $event"
                    :label="$translate.text('general.company.phone')"
                />

                <TextInput
                    id="clientWebsite"
                    :value="clientWebsite"
                    name="clientWebsite"
                    @change="clientWebsite = $event"
                    :label="$translate.text('general.company.website')"
                />

                <h4>{{ t('general.contact_information') }}</h4>

                <TextInput
                    id="clientContactName"
                    :value="clientContactName"
                    name="clientContactName"
                    @change="clientContactName = $event"
                    :label="$translate.text('general.contact.name')"
                />

                <TextInput
                    id="clientContactNumber"
                    :value="clientContactNumber"
                    name="clientContactNumber"
                    @change="clientContactNumber = $event"
                    :label="$translate.text('general.company.phone')"
                />

                <EmailInput
                    id="email"
                    :value="email"
                    name="email"
                    @change="email = $event"
                    :label="$translate.text('general.email')"
                />

<!--                <Select-->
<!--                    id="language"-->
<!--                    :value="language"-->
<!--                    name="language"-->
<!--                    @change="language = $event"-->
<!--                    :options="options"-->
<!--                    :label="$translate.text('locales.preferred_language')"-->
<!--                />-->

                <h4>{{ t('general.extra_information') }}</h4>

                <TextInput
                    id="clientKvk"
                    :value="clientKvk"
                    name="clientKvk"
                    @change="clientKvk = $event"
                    :label="$translate.text('general.company.chamber_of_commerce')"
                />

                <TextInput
                    id="clientBTW"
                    :value="clientBTW"
                    name="clientBTW"
                    @change="clientBTW = $event"
                    :label="$translate.text('general.company.vat_number')"
                />

                <FormSubmit
                    :routeAfterCancelLink="{ name: 'Admin Resellers' }"
                    :buttonLabel="submittingIsLoading ? $translate.text('general.send_invitation.sending') :  $translate.text('general.send_invitation')"
                    :disabled="submittingIsLoading"
                />
            </form>
        </div>
    </main>
</template>
<script>
import swal from 'sweetalert';
import { post } from '@/helpers/http';
import handleError from '@/helpers/error';
import { getUser } from '@/helpers/auth';

import PageHeader from '@/components/PageHeader/PageHeader';
import TextInput from '@/components/Inputs/TextInput';
import EmailInput from '@/components/Inputs/EmailInput';
import Select from '@/components/Inputs/Select';
import FormSubmit from '@/components/Forms/FormSubmit';

export default {
    name: 'AddClient',

    components: {
        PageHeader,
        TextInput,
        EmailInput,
        // Select,
        FormSubmit,
    },

    data() {
        return {
            company: '',
            clientStreet: '',
            clientZipcode: '',
            clientCity: '',
            clientPhone: '',
            clientWebsite: '',
            clientLogo: '',
            clientContactName: '',
            clientContactNumber: '',
            clientBTW: '',
            clientKvk: '',
            email: '',
            language: 'nl_NL',
            options: [
                { label: this.$translate.text('locales.dutch'), value: 'nl_NL' },
                { label: this.$translate.text('locales.english'), value: 'en_EN' },
                { label: this.$translate.text('locales.german'), value: 'de_DE' },
            ],

            submittingIsLoading: false,
        };
    },

    methods: {
        submitForm() {
            this.submittingIsLoading = true;
            const user = getUser();
            post({
                url: `${this.$API_URL}/api/resellers/clients`,
                data: {
                    company_name: this.company,
                    street: this.clientStreet,
                    zipcode: this.clientZipcode,
                    city: this.clientCity,
                    phonenumber: this.clientPhone,
                    website: this.clientWebsite,
                    logo_path: this.clientLogo,
                    contact_name: this.clientContactName,
                    contact_number: this.clientContactNumber,
                    btw: this.clientBTW,
                    kvk: this.clientKvk,
                    language: this.language,
                    email: this.email,
                    reseller_id: user.reseller.id,
                },
            })
                .then(() => {
                    this.submittingIsLoading = false;
                    swal({
                        title: this.$translate.text('alert.success'),
                        text: this.$translate.text('alert.title.invitation.send'),
                    }).then(() => {
                        this.resetForm();
                        this.$router.push({ name: 'Resellers Dashboard' });
                    });
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        resetForm() {
            this.company = '';
            this.clientStreet = '';
            this.clientZipcode = '';
            this.clientCity = '';
            this.clientPhone = '';
            this.clientWebsite = '';
            this.clientLogo = '';
            this.clientContactName = '';
            this.clientContactNumber = '';
            this.clientBTW = '';
            this.clientKvk = '';
            this.email = '';
            this.language = 'nl_NL';
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
